import { useSession } from '@tgtg/core/session';
import charityVettingApiSlice from 'api/charity-vetting/charityVettingApiSlice';
import { useVettingDocuments } from 'features/charity-vetting/country-specific-flows/fr-flow/useVettingDocuments';
import { CountryCodeEnum } from 'features/charity-vetting/types/charityVettingTypes';
import { parseCountryParam } from 'features/charity-vetting/utils/countryHandlers';
import { resolveResumeStep } from 'features/charity-vetting/utils/resolveResumeStep';
import { useIntl } from 'react-intl';
import { Navigate, useLocation } from 'react-router';
import { VETTING_PROGRESS_PATH } from 'src/core/paths/paths';

import { getCountryCodeFromStorage, setCharityVettingUserEmail } from '../../utils/storageHandlers';
import CharityVettingCountryManagerContainer from '../containers/CharityVettingCountryManagerContainer';
import CharityVettingFormProvider from '../containers/CharityVettingFormProvider';

const CharityVettingEntry = () => {
  const location = useLocation();
  const { pathname, search } = location;
  const { session } = useSession();
  const { formatMessage } = useIntl();

  setCharityVettingUserEmail(session.userEmail);

  const isRootPath = pathname.endsWith('/charity-vetting');

  const { data: vetting, isLoading: isVettingLoading } =
    charityVettingApiSlice.endpoints.getCharityVetting.useQuery(undefined, { skip: !isRootPath });

  const country =
    parseCountryParam(search) ?? getCountryCodeFromStorage() ?? vetting?.countryIsoCode ?? null;
  const {
    documents,
    isLoading: isDocumentsLoading,
    isError: isDocumentsError,
  } = useVettingDocuments(country === CountryCodeEnum.FR);

  if (pathname.endsWith('/')) {
    return <Navigate to={{ pathname: pathname.slice(0, -1) }} />;
  }

  if (isRootPath) {
    if (isVettingLoading || isDocumentsLoading) {
      return null;
    }

    const resumePath = resolveResumeStep(
      vetting,
      country ?? CountryCodeEnum.GB,
      formatMessage,
      documents,
      isDocumentsError,
    );
    // A null path means the wizard is already submitted → progress page.
    return <Navigate to={resumePath ?? VETTING_PROGRESS_PATH} replace />;
  }

  return (
    <CharityVettingFormProvider key={pathname}>
      <CharityVettingCountryManagerContainer />
    </CharityVettingFormProvider>
  );
};

export default CharityVettingEntry;
